import React from 'react'
import Logoar from "./pics/logo.jpeg";
import Share from "../../components/share.js";
import "./jawaan.css" 
import img from "./pics/sapta.png";
const sapta = () => { 
  return  (
 
    <div className="shortstory-container">
        <img src={Logoar} alt="Logoar" className="logoarr" />
      <div className="blue-bg">
     
      
        
        <header class="entry-header">
		<h4 class="entry-meta"><a href="https://nooffensebut.vercel.app/MovieReviews" target='_blank' data-wpel-link="internal">Movie and Show Reviews</a></h4>
		<h1 class="entry-title">Sapta Sagaradaache Ello - Side A</h1>
		<div class="entry-meta">
			<span class="byline">by <span class="author vcard"><a class="url fn n" href="https://nooffensebut.vercel.app/aboutus" target='_blank' data-wpel-link="internal">Harshala</a></span></span><span class="meta-divider"> | </span><span class="posted-on"><a href="https://nooffensebut.vercel.app/content" target='_blank' rel="bookmark" data-wpel-link="internal"><time class="entry-date published" datetime="2018-03-01T07:27:10-05:00">12.10.2023</time><time class="updated" datetime="2018-03-01T11:10:42-05:00"></time></a><span>		</span></span></div>
	</header>
       
 
  <img src={img} alt="Logoar" className="moo" />

        <div className="description1-2">
            <div className="rate">Rating: 3.5</div> <div className="genre">Genre: Romance,Drama</div>
          
            <p>It is undoubtedly one of the most heartwarming and genuine romances I've come across in recent times. While the story may progress at a leisurely pace and lacks intricate plot twists, its ability to evoke genuine emotion, often bringing tears to the audience's eyes, sets it apart. The film's close-to-reality portrayal is what makes it truly special, with minimal makeup used on the actors to enhance the authenticity of their characters.</p>
<br/>
<p>The love shared between Manu and Priya is beautifully depicted, celebrating the significance of small gestures and the unwavering bond they share. Their ability to hold onto each other and their love, even in the face of adversity, is a testament to the strength of their relationship. Both hail from lower-middle-class backgrounds, marked by their determination to achieve their dreams and improve their living conditions, a portrayal that resonates with authenticity.</p>
<br/>
<p>The film takes an unexpected turn when Manu makes a fateful decision to fulfill Priya's dream, leading the audience through a rollercoaster of emotions, particularly during the challenging moments within the confines of a jail.</p>
<br/>
<p>Rakshith Shetty and Rukmini Vasanth deliver commendable performances, breathing life into their characters and doing justice to their roles, which adds to the film's overall appeal.</p>
<br/>
<p>In summary, "Sapta Sagaradaache Ello - Side A" is a fantastic cinematic experience, albeit at a slower pace. The audience can eagerly anticipate the release of "Sapta Sagaradaache Ello - Side B" on October 27th, hoping for another emotional and captivating chapter in this beautiful tale of love.</p><br/>


    <hr></hr>
</div>



          <Share/>
      </div>
</div> )}

export default sapta;

 


